<template>
  <div class="profile-edit-page">
    <a-card :bordered="false" class="profile-card">
      <template slot="title">
        <div class="card-title-row">
          <div class="card-title-left">
            <a-button type="link" size="small" @click="$router.back()" style="padding: 0; margin-right: 8px;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
            </a-button>
            <span class="card-title-text">编辑个人信息</span>
          </div>
        </div>
      </template>

      <a-form-model
        ref="editForm"
        :model="form"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="用户名" prop="user_name">
          <a-input v-model="form.user_name" placeholder="请输入用户名" />
        </a-form-model-item>

        <a-form-model-item label="昵称" prop="nickname">
          <a-input v-model="form.nickname" placeholder="请输入昵称（可选）" />
        </a-form-model-item>

        <a-form-model-item label="邮箱" prop="user_mail">
          <a-input v-model="form.user_mail" placeholder="请输入邮箱（可选）" />
        </a-form-model-item>

        <a-form-model-item label="手机号">
          <a-input v-model="form.mobile" disabled />
          <span class="field-hint">手机号不可修改</span>
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ offset: 5, span: 14 }">
          <div class="form-actions">
            <a-button @click="$router.back()">取消</a-button>
            <a-button type="primary" :loading="submitting" @click="handleSubmit">保存修改</a-button>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WodeEdit',
  data() {
    // 邮箱验证
    const emailValidator = (rule, value, callback) => {
      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        callback(new Error('请输入正确的邮箱格式'));
      } else {
        callback();
      }
    };

    return {
      submitting: false,
      form: {
        user_name: '',
        nickname: '',
        user_mail: '',
        mobile: ''
      },
      rules: {
        user_name: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        user_mail: [
          { validator: emailValidator, trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters('main/user', ['info'])
  },
  created() {
    if (this.info) {
      this.form = {
        user_name: this.info.user_name || '',
        nickname: this.info.nickname || '',
        user_mail: this.info.user_mail || '',
        mobile: this.info.mobile || ''
      };
    }
  },
  methods: {
    async handleSubmit() {
      try {
        await this.$refs.editForm.validate();
      } catch {
        return;
      }

      this.submitting = true;
      try {
        const userId = this.info?.id;
        const payload = {
          user_name: this.form.user_name,
          nickname: this.form.nickname || undefined,
          user_mail: this.form.user_mail || undefined
        };

        const res = await this.$api.update_user(userId, payload);
        if (res && res.code === 200) {
          this.$message.success('信息修改成功');
          // 更新 store 中的用户信息
          this.$store.commit('main/user/SET_INFO', res.data);
          localStorage.setItem('aoxy-user', JSON.stringify(res.data));
          this.$router.back();
        } else {
          this.$message.error(res?.message || '修改失败');
        }
      } catch (err) {
        console.error('[wode-edit] submit error:', err);
        this.$message.error('网络异常，请稍后重试');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.profile-edit-page {
  max-width: 900px;
  margin: 0 auto;
}

.profile-card {
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.card-title-left {
  display: flex;
  align-items: center;
  gap: 4px;
}

.card-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.field-hint {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px;
  display: inline-block;
}
</style>
